var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCup = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66699 9.292V10.6667H12.0003V12H4.00033V10.6667H7.33366V9.292C6.04479 9.12947 4.85954 8.50218 4.00033 7.52783C3.14112 6.55349 2.66701 5.29907 2.66699 4V0H13.3337V4C13.3336 5.29907 12.8595 6.55349 12.0003 7.52783C11.1411 8.50218 9.95586 9.12947 8.66699 9.292ZM0.666992 1.33333H2.00033V4H0.666992V1.33333ZM14.0003 1.33333H15.3337V4H14.0003V1.33333Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCup, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cup.cf43a600.svg";
export { ForwardRef as ReactComponent };